<template>
  <div class="mb-4 md:mb-0 flex items-center" v-for="provider in providers" :key="provider.slug">
    <img :src="provider.icon" alt="" class="icon icon-md mr-1.5" loading="lazy" />
    <span class="font-semibold text-16 truncate">{{ provider.displayName }}</span>
  </div>
</template>

<script lang="ts" setup>
import type { PromoProvider } from '../types'

defineProps<{
  providers?: PromoProvider[]
}>()
</script>
